import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LoaderService } from '../shared/services/loader.service';
import { ApiOrganizationService } from './api-organization.service'; 
import { ToastrService } from 'ngx-toastr';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { NavService } from '../shared/services/nav.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationLoginService {
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  isLoggedIn$ = this.isAuthenticatedSubject.asObservable();
  selectedRole$ =  new BehaviorSubject<string>('Organization');
  authStateSubscription: Subscription;
  roleType: string;
  org = localStorage.getItem('orgName')
  orgName$:BehaviorSubject<any> = new BehaviorSubject<any>(JSON.parse(this.org));
  googleToken: any;
  constructor(private router: Router, public navServices: NavService, private loaderService: LoaderService, private apiOrganizationService: ApiOrganizationService, private toastr: ToastrService,private authService: SocialAuthService) {}

  login(userName: string, password: string, isRoute: boolean = true): void {
    // Handles the login process for organization users
    let data = {
      user_name: userName,
      password: password
    };
    this.loaderService.showLoader();
    this.apiOrganizationService.login(data).subscribe({
      next: (res: any) => {
        localStorage.setItem('organizationToken', res.data.accessToken);
        localStorage.setItem('orgName', JSON.stringify(res.data?.name));
        localStorage.setItem('orgRole', JSON.stringify(res.data?.role));
        localStorage.setItem('expired_at', JSON.stringify(res.data?.expired_at));
        localStorage.setItem('code', JSON.stringify(res.data?.code));    
        this.isAuthenticatedSubject.next(true);
        this.orgName$.next(res.data?.name);
        if(isRoute === false) {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/organization/dashboard']);
          });
        }else {
          this.router.navigate(['/organization/dashboard']);
        }
        this.toastr.success(res.message);
        this.loaderService.hideLoader();
      }, error: (err: any) => {
        if (err.status === 404) {
          this.toastr.error('Organization not found. Please check your credentials.');
        } else {
          this.toastr.error('Organization login failed. Please try again later.');
        }
        this.loaderService.hideLoader();
      }
    });
  }

  // Handles Google login for organization users
  googleLogin() {
    if (this.authStateSubscription) {
      this.authStateSubscription.unsubscribe();
    }    
    this.selectedRole$.subscribe((role:any) => {
       this.roleType = role;
    })
    this.authStateSubscription = this.authService.authState.subscribe((user) => {
      if (user && user.idToken !== this.googleToken) {  
        this.googleToken = user?.idToken; 
        let requestBody = {
          id_token: this.googleToken,
        };
        if(this.roleType === 'Organization') {
          this.orgSocialLogin(requestBody);
        }
      }
    })
  }

  // Handles social login for organization users
  orgSocialLogin(data: any) {
    this.loaderService.showLoader();
    let requestBody =  data ;
    this.apiOrganizationService.socialLogin(requestBody).subscribe({
      next: (res: any) => {
        localStorage.setItem('organizationToken', res.data.accessToken);
        localStorage.setItem('orgName', JSON.stringify(res.data?.name));
        localStorage.setItem('orgRole', JSON.stringify(res.data?.role));
        this.isAuthenticatedSubject.next(true);
        this.orgName$.next(res.data?.name);
        this.router.navigate(['/organization/dashboard']);
        this.toastr.success(res.message);
        localStorage.setItem('expired_at', JSON.stringify(res.data?.expired_at));
        this.loaderService.hideLoader();
      }, error: (err: any) => {
        if (err.status === 404) {
          this.toastr.error('Organization not found. Please check your credentials.');
        } else {
          this.toastr.error('Organization login failed. Please try again later.');
        }
        this.loaderService.hideLoader();
      }
    });
  }

  // Logs out the user and clears relevant localStorage data
  logout(isRoute: boolean = true): void {
    localStorage.removeItem('organizationToken');
    localStorage.removeItem('orgName');
    localStorage.removeItem('orgRole');
    localStorage.removeItem('expired_at');
    localStorage.removeItem('code');
    this.isAuthenticatedSubject.next(false);
    //isRoute is used to check if the user is logged out from the logout Button or from the header
    if(isRoute === true) {
      this.router.navigate(['login']);
    }else if (isRoute === false) {
      //if false its means user is logged out from the header , so we need to set the selected role to Staff
      localStorage.setItem('selectedRole', 'Staff')
    }
    if (this.authStateSubscription) {
      this.authStateSubscription.unsubscribe();
    }
    this.authService.signOut().then(() => {
      this.googleToken = null;
    })
    .catch((error) => {});
  }

  // Retrieves the authentication token from localStorage
  getOrganizationToken(): string | null {
    return localStorage.getItem('organizationToken');
  }

  // Checks if the user is logged in by verifying the presence of a token
  isOrganizationLoggedIn(): boolean {
    return this.getOrganizationToken() !== null;
  }
}
